import { Box, styled, Typography } from '@mui/material';
import { fontFamily } from 'theme/overrides/fontFamily';

export const StyledDiscoveryTiles = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
  gridGap: theme.spacing(3),
  overflowX: 'auto',
  paddingBottom: theme.spacing(3),

  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'repeat(12, 35vw)',
  },
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(12, 12rem)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(6, 1fr)',
  },
}));

export const StyledDiscoverySectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: fontFamily.roboto,
  fontSize: 16,
  fontWeight: 700,
  marginBottom: theme.spacing(2),
}));
